document.addEventListener('DOMContentLoaded', () => {
  const pick = document.querySelectorAll('.pick-plan span');
  const atcBtn = document.querySelector('button[data-add-to-cart]');
  const showStrikeThroughPrice = atcBtn.getAttribute('data-show-strikethrough-price');
  const defaultAtcText = atcBtn.querySelector('[data-add-to-cart-text]').dataset.defaultText;
  const quantityInput = document.querySelector('.n-product .product__quantity input');
  const sItems = document.querySelectorAll('.month-plan .subscribe-pack .item');
  const oItems = document.querySelectorAll('.month-plan .one-time-pack .item');

  if (pick.length) {
    pick.forEach((a) => {
      a.addEventListener('click', function () {
        for (let i = 0; i < pick.length; i++) {
          pick[i].classList.remove('active');
        }
        this.classList.add('active');
      });
    });

    document.querySelector('.pick-plan .subscribe').addEventListener('click', () => {
      oItems[0].click();
      document.querySelector('.month-plan .pack-size-selector__subscribe').classList.remove('hide');
      document.querySelector('.month-plan .pack-size-selector__one-time').classList.add('hide');
      document.querySelector('.n-product__buy-buttons .product__quantity').classList.add('hide');

      setTimeout(() => {
        const SKIO = document.querySelector('skio-plan-picker');
        if (SKIO && SKIO.selectedVariant.selling_plan_allocations[0]) {
          SKIO.selectSellingPlanGroup(SKIO.selectedVariant.selling_plan_allocations[0].selling_plan_group_id)
          SKIO.selectSellingPlan(SKIO.selectedVariant.selling_plan_allocations[0].selling_plan_id)
        } else {
          console.log('SKIO not found');
        }
        setTimeout(() => {
          if (atcBtn) atcBtn.innerHTML = defaultAtcText + ' | ' + document.querySelectorAll('.subscribe-pack .variant-input .item.selected .price')[0].innerHTML + (showStrikeThroughPrice ? document.querySelectorAll('.subscribe-pack .variant-input .item.selected .compare')[0] ? ('<span class="compare">' + document.querySelectorAll('.subscribe-pack .variant-input .item.selected .compare')[0].innerHTML + '</span>') : '' : '');
        }, 100);
      }, 200);
      
    });
    document.querySelector('.pick-plan .oneTime').addEventListener('click', () => {
      document.querySelector('.month-plan .pack-size-selector__subscribe').classList.add('hide');
      document.querySelector('.month-plan .pack-size-selector__one-time').classList.remove('hide');
      document.querySelector('.n-product__buy-buttons .product__quantity').classList.remove('hide');

      setTimeout(() => {
        const SKIO = document.querySelector('skio-plan-picker');
        if (SKIO) {
          SKIO.selectSellingPlanGroup(null)
        } else {
          console.log('SKIO not found')
        }
        setTimeout(() => {
          if (atcBtn) atcBtn.innerHTML = defaultAtcText + ' | ' + '$' + Number(Number(document.querySelectorAll('.one-time-pack .variant-input .item.selected .price')[0].innerHTML.split('$')[1]) * quantityInput.value).toFixed(2) + (showStrikeThroughPrice ? document.querySelectorAll('.one-time-pack .variant-input .item.selected .compare')[0] ? ('<span class="compare">$' + Number(Number(document.querySelectorAll('.one-time-pack .variant-input .item.selected .compare')[0].innerHTML.split('$')[1]) * quantityInput.value).toFixed(2) + '</span>') : '' : '');
        }, 100);
      }, 200);      
    });

    sItems.forEach((a) => {
      a.addEventListener('click', function () {
        for (let j = 0; j < oItems.length; j++) {
          oItems[j].classList.remove('selected');
        } 
        for (let i = 0; i < sItems.length; i++) {
          if (this == sItems[i]) {
            this.classList.add('selected');
            if (oItems[i]) {
              oItems[i].classList.add('selected');
            } else {
              oItems[oItems.length - 1].classList.add('selected');
            }
            if (atcBtn) atcBtn.innerHTML = defaultAtcText + ' | ' + sItems[i].querySelector('.price').innerHTML + (showStrikeThroughPrice ? sItems[i].querySelector('.compare') ? ('<span class="compare">' + sItems[i].querySelector('.compare').innerHTML + '</span>') : '' : '');
          } else {
            sItems[i].classList.remove('selected');             
          }
        }
      });
    });

    oItems.forEach((a) => {
      a.addEventListener('click', function () {
        for (let j = 0; j < sItems.length; j++) {
          sItems[j].classList.remove('selected');
        }
        for (let i = 0; i < oItems.length; i++) {
          if (this == oItems[i]) {
            this.classList.add('selected');
            if (sItems[i]) {
              sItems[i].classList.add('selected');
            } else {
              sItems[sItems.length - 1].classList.add('selected');
            }       
            if (atcBtn) atcBtn.innerHTML = defaultAtcText + ' | ' + '$' + Number(Number(oItems[i].querySelector('.price').innerHTML.split('$')[1]) * quantityInput.value).toFixed(2) + (showStrikeThroughPrice ? oItems[i].querySelector('.compare') ? ('<span class="compare">$' + Number(Number(oItems[i].querySelector('.compare').innerHTML.split('$')[1]) * quantityInput.value).toFixed(2) + '</span>') : '' : '');
          } else {
            oItems[i].classList.remove('selected');
          }
        }
      });
    });

    quantityInput.parentElement.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', function () {
        setTimeout(() => {
          if (atcBtn) atcBtn.innerHTML = defaultAtcText + ' | ' + '$' + Number(Number(document.querySelectorAll('.variant-input .item.selected .price')[0].innerHTML.split('$')[1]) * quantityInput.value).toFixed(2) + (showStrikeThroughPrice ? ('<span class="compare">$' + Number(Number(document.querySelectorAll('.variant-input .item.selected .compare')[0].innerHTML.split('$')[1]) * quantityInput.value).toFixed(2) + '</span>') : '');
        }, 100);
      })
    });
  }

  const pMetafieldInfoLists = document.querySelectorAll('.product-metafield li');
  let addCheckHtml = '';
  if (pMetafieldInfoLists.length > 0) {
    pMetafieldInfoLists.forEach((info) => {
      addCheckHtml += '<div class="product-metafield__item"><span></span><li>' + info.innerHTML + '</li></div>';
    });

    document.querySelector('.product-metafield ul').innerHTML = addCheckHtml;
  }
})